import React from "react";

export const LeftSideSkeleton = () => (
  <div className="space-y-6">
    <div className="space-y-2">
      <div className="h-8 w-32 bg-gray-200 rounded animate-pulse"></div>
      <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div className="space-y-1">
      <div className="h-4 w-48 bg-gray-200 rounded animate-pulse"></div>
      <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
    </div>
  </div>
);

export const MeetingDetailsSkeleton = () => (
  <div className="mb-6 pb-6 border-b border-gray-200">
    <div className="flex items-center gap-3 mb-4">
      <div className="w-6 h-6 bg-gray-200 rounded-full animate-pulse"></div>
      <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div className="mb-4">
      <div className="h-6 w-32 bg-gray-200 rounded animate-pulse mb-2"></div>
      <div className="h-4 w-48 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
        <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
        <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
        <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
      </div>
    </div>
  </div>
);

export const CalendarSkeleton = () => (
  <>
    <div className="mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-baseline gap-1">
          <div className="h-5 w-16 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-8 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div className="flex gap-1">
          <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
          <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>

    <div className="grid grid-cols-7 gap-0 mb-2">
      {Array.from({ length: 7 }).map((_, index) => (
        <div key={index} className="text-center py-2">
          <div className="h-3 w-8 bg-gray-200 rounded animate-pulse mx-auto"></div>
        </div>
      ))}
    </div>

    <div className="grid grid-cols-7 gap-0">
      {Array.from({ length: 35 }).map((_, index) => (
        <div
          key={index}
          className="w-10 h-10 md:w-12 md:h-12 bg-gray-200 rounded animate-pulse"
        ></div>
      ))}
    </div>
  </>
);

export const TimeSelectionSkeleton = () => (
  <div className="p-5 flex-1">
    <div className="flex items-center gap-4 mb-6">
      <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
      <div className="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="p-3 border border-gray-200 rounded-lg">
          <div className="h-4 w-16 bg-gray-200 rounded animate-pulse mx-auto"></div>
        </div>
      ))}
    </div>
  </div>
);

export const ConfirmationSkeleton = () => (
  <div className="p-5 flex-1">
    <div className="flex items-center gap-4 mb-6">
      <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
      <div className="h-6 w-40 bg-gray-200 rounded animate-pulse"></div>
    </div>
    <div className="grid md:grid-cols-1 gap-4 mb-6">
      <div className="bg-gray-50 rounded-lg p-4">
        <div className="h-5 w-24 bg-gray-200 rounded animate-pulse mb-3"></div>
        <div className="space-y-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="flex justify-between">
              <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="flex justify-center">
      <div className="h-10 w-32 bg-gray-200 rounded-full animate-pulse"></div>
    </div>
  </div>
);
